import { render } from "./TabsView.vue?vue&type=template&id=637875e6&ts=true"
import script from "./TabsView.vue?vue&type=script&lang=ts"
export * from "./TabsView.vue?vue&type=script&lang=ts"

import "./TabsView.vue?vue&type=style&index=0&id=637875e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__